// extracted by mini-css-extract-plugin
export default {"redeemReport":"RedeemReport_redeemReport__-3Fyi","teamTitle":"RedeemReport_teamTitle__vtZm+","backBtn":"RedeemReport_backBtn__mYALm"};